import { gql } from '@apollo/client';

export const QUERY_SKILLS = gql`
  query skills {
    skills {
      id
      name
      selectable
      childObjects {
        id
        name
        selectable
      }
    }
    skillLevels {
      id
      code
      name
      enabled
      sortOrder
    }
  }
`;
